import { useNavigate } from "react-router-dom";
import { CloudUpload } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Shown on every journey step for guests: an account is optional but saves progress permanently.
export const GuestSaveBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="pointer-events-none fixed right-3 top-3 z-40 sm:right-5 sm:top-5">
      <Popover>
        <PopoverTrigger asChild>
          <button data-testid="guest-save-trigger"
            className="pointer-events-auto inline-flex items-center gap-2 rounded-full bg-white/85 px-3.5 py-2 text-[12.5px] font-medium text-slate-700 shadow-[0_10px_30px_-18px_rgba(15,23,42,0.5)] ring-1 ring-slate-200 backdrop-blur-xl transition-colors hover:text-teal-700">
            <CloudUpload className="h-4 w-4 text-teal-600" /> Guest · Save my progress
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" sideOffset={8} data-testid="guest-save-popover"
          className="w-[min(320px,calc(100vw-1.5rem))] rounded-3xl border-white/80 bg-white/95 p-5 backdrop-blur-xl">
          <p className="font-heading text-base font-bold text-slate-900">You're exploring as a guest</p>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">
            Your progress is kept privately for 7 days. A free account saves it permanently (under our normal account retention policies), so you can come back any time, on any device. Everything so far moves into your account.
          </p>
          <div className="mt-4 flex flex-col gap-2">
            <button data-testid="guest-save-create" onClick={() => navigate("/begin?next=journey")}
              className="rounded-full bg-teal-600 px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-teal-700">Create my free account</button>
            <button data-testid="guest-save-login" onClick={() => navigate("/login?next=journey")}
              className="rounded-full px-4 py-2 text-sm font-medium text-slate-600 transition-colors hover:text-slate-900">I already have an account</button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};
